import { Box } from "@mui/material";
import { fileNameIsImage } from "../../utils/utils";

/**
 * FileViewer component to display different types of files (images, PDFs, etc.)
 *
 * @param {File} props.file - The file object.
 * @param {string} props.fileName - The name of the file.
 * @returns {JSX.Element} - A component that renders the file preview.
 */
const FileViewer = ({ file, fileName }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {fileNameIsImage(fileName) ? (
        <Box
          component="img"
          src={file.filePath ?? file}
          alt="File preview"
          sx={{
            maxWidth: "100%",
            maxHeight: "100%",
            width: "auto",
            height: "auto",
            objectFit: "contain",
          }}
        />
      ) : (
        <object data={file.filePath ?? file} width="100%" height="100%">
          <p>File type not supported</p>
        </object>
      )}
    </Box>
  );
};

export default FileViewer;
